import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';
import get from 'lodash.get';

// Selectors
import {
    selectAllGroupIds,
    selectHarvestEventsQuantityScheduleTotalsByGroupId
} from '../../../../selectors';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

type State = *;

interface Props {
    groupId?: number;
}

const selectGroupId = (state: State, props: Props) => props.groupId || 'null';

const makeSelectQuantitySchedulesTotalForGroup = () =>
    createDeepEqualSelector(
        [selectGroupId, selectHarvestEventsQuantityScheduleTotalsByGroupId],
        (groupId, harvestEventsQuantityScheduleTotalsByGroupIdState) =>
            get(harvestEventsQuantityScheduleTotalsByGroupIdState, groupId, 0)
    );

// Has error if groups doen't belong to current top level entity
const makeSelectHasError = () =>
    createDeepEqualSelector(
        [selectAllGroupIds, selectGroupId],
        (allGroupIdsState, groupIdState) =>
            !allGroupIdsState.includes(groupIdState)
    );

export { makeSelectQuantitySchedulesTotalForGroup, makeSelectHasError };
